export enum StatusDeclarationEnum {
    Progress = 'PROGRESS',
    NotApplicable = 'NOT_APPLICABLE',
    Finished = 'FINISHED',
    Pending = 'PENDING'
  }

  